import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { STALE_TIME } from './common'
import * as PlaceImageKeys from '../reactQueryKeys/placeImage'

import { getGooglePlacePhoto } from 'tripPlanner/api/places'
import {
  GetGoogleImageError,
  GetGoogleImageResponse,
} from 'tripPlanner/api/places/types'

// This hook is used to fetch a single image for a place when we already know the name of the resource
export const usePlaceImageName = ({
  name,
  options,
}: {
  name: string
  options?: UseQueryOptions<
    GetGoogleImageResponse['result'],
    GetGoogleImageError,
    App.Image
  >
}) => {
  return useQuery({
    queryKey: PlaceImageKeys.googlePlaceImage(name),
    queryFn: () => getGooglePlacePhoto(name),
    staleTime: STALE_TIME,
    select: (data) => {
      return { id: data.name, url: data.photoUri }
    },
    ...options,
  })
}
